export default __webpack_public_path__ + "static/media/sort-desc-arrow.67880be9.svg";